var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-title',[_vm._v(" "+_vm._s(_vm.$t('title'))+" ")]),_c('v-card-text',[_c('div',{staticClass:"d-flex justify-space-between"},[_c('div',[_vm._v(_vm._s(_vm.$t('warning')))]),_c('div',[_c('v-btn',{attrs:{"color":"red lighten-4","small":"","dense":""},on:{"click":_vm.deleteCustomer}},[_vm._v(_vm._s(_vm.$t('title')))])],1)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }